import { render, staticRenderFns } from "./DealDetailDetail.vue?vue&type=template&id=126a926a&scoped=true&"
import script from "./DealDetailDetail.vue?vue&type=script&lang=js&"
export * from "./DealDetailDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126a926a",
  null
  
)

export default component.exports